import React, { Component } from 'react';

import Select from 'react-select';
import Creatable from 'react-select';
import Button from 'components/Button';
// import 'react-select/dist/react-select.css';
import 'sass/components/react-select';

export default class ContentHeader extends Component {

	fixedBtnOption () {
		var button = false;
		if (this.props.fixedBtn) {
			button = (<Button
				onClick={this.props.btnAction.bind(this, this.props.value)}
				label={this.props.fixedBtn}
				icon={this.props.fixedBtnIcon}
				buttonClass="fixed-typeahead-btn"
			/>);
		}
		return button;
	}

	onNewOption(newOption) {
		return {
			value: newOption.label,
			label: newOption.label,
			className: 'Select-create-option-placeholder'
		};
	}

	render () {
		let addNewOption = (value) => { return { value, label: value }; }
		let options = this.props.options;
        if(this.props.sortOptions) {
            options.sort(function(a, b) {
                a = a.label.toLowerCase();
                b = b.label.toLowerCase();
                if (a < b) return -1;
                if (a > b) return 1;
                return 0;
            });
        }

		function logChange(val) {
			console.log(val);
				console.log("Selected: " + val);
		}

		return (
			<div className="has-fixed-btn">
				{/*<Creatable
					newOptionCreator={this.onNewOption}
					name="form-field-name"
					value="one"
					options={options}
					onChange={logChange}
				/>*/}
				<Select
					name={this.props.name}
					value={this.props.value}
					options={options}
					onChange={this.props.onChange}
				/>
				{this.fixedBtnOption()}
			</div>
		);
	}
}


// WEBPACK FOOTER //
// ./js/components/Typeahead.js